import React, { useEffect } from 'react';
import { GlobalState } from '../../../redux/root-reducer';
import { connect } from 'react-redux';
import { User } from '../../../@types/user.interface';
import ViewScores from '../../../components/view-scores/view-scores.component';
import { Dispatch } from 'redux';
import { fetchApi } from '../../../redux/fetch/fetch.actions';
import ScoreActionAPI, {
    IFetchScoresPayload,
} from '../../../redux/score/score.actions';
import Score from '../../../@types/score.interface';

interface IProps {
    isFetching?: boolean;
    errors?: string | null;
    user: User | null;
    scores: Score[] | null;
    fetchScores: (data: IFetchScoresPayload['data']) => void;
    clearScores: () => void;
}

function ViewScoresContainer({
    isFetching,
    errors,
    user,
    scores,
    fetchScores,
    clearScores,
}: IProps) {
    useEffect(() => {
        clearScores();
    }, [clearScores]);

    useEffect(() => {
        if (scores === null && user?.email_address)
            fetchScores({ email_address: user?.email_address });
    }, [user, scores, fetchScores]);

    return (
        <div className="container">
            <div className="container__content">
                <div className="home-student">
                    {isFetching === false ? <ViewScores scores={scores} /> : null }
                    
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
    user: {
        self: { data },
    },
    score: { scores },
}: GlobalState) => ({
    isFetching: isFetching.SCORES,
    errors: errors.SCORES,
    user: data,
    scores,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchScores: (data: IFetchScoresPayload['data']) =>
        dispatch(fetchApi({ name: 'SCORES', data: data })),
    clearScores: () => dispatch(ScoreActionAPI.clearScores()),
});

const ScoresPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewScoresContainer);

export default ScoresPage;
